import Component from '@glimmer/component';
import { set } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { Changeset } from 'ember-changeset';
import { isPresent } from '@ember/utils';

/*
  args
    - contact
*/

export default class ContactDetailsPhonesComponent extends Component {
  @service abilities;

  @tracked editing = false;
  @tracked changesets;
  @tracked saveError;

  get showEditIcon() {
    return this.abilities.hasAbility('edit_contact') && !this.editing;
  }

  createChangeset(item) {
    return Changeset(item);
  }

  reset = () => {
    this.editing = false;
    this.changesets = undefined;
    this.saveError = undefined;;
  }

  setEditing = (val) => {
    this.editing = val;
    if (this.editing) {
      let copiedItems = JSON.parse(
        JSON.stringify(this.args.contact.phones?.data || []),
      );
      this.changesets = copiedItems.map((x) => this.createChangeset(x));
      if (this.changesets.length === 0) {
        this.addPhone();
      }
    }
  }

  addPhone = () => {
    this.changesets = [...this.changesets, this.createChangeset({})];
  }

  deletePhone = (index) => {
    this.changesets.splice(index, 1);
    this.changesets = this.changesets.slice();
  }

  save = async () => {
    this.changesets.forEach((x) => x.execute());
    if (this.args.contact.phones == null) {
      this.args.contact.phones = {};
    }

    let dataItemsToSave = this.changesets
      .map((x) => x.data)
      .filter((x) => isPresent(x.v));
    dataItemsToSave.forEach((x) => {
      set(x, 'v', x.v.trim());
      if (isPresent(x.l)) {
        set(x, 'l', x.l.trim());
      }
    });

    try {
      this.args.contact.phones = {
        ...this.args.contact.phones,
        data: dataItemsToSave
      };
      this.editing = false;
      await this.args.contact.save();
    } catch (e) {
      this.saveError = e;
      this.editing = true;
      await this.args.contact.reload();
    }
  }
}
